import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import utils from "../../utils/utils";
import validationHelper from "../../utils/validationHelper";
import SelfMedicalInfoTab from "./PatientTabs/SelfMedicalInfoTab";
import AlertConfirm from "../../components/modals/Confirm";
import SelfUseOfCannabisTab from "./PatientTabs/SelfUseOfCannabisTab";
import patientApi from "../../services/ApiServices/patientApi";
import SelfSymptomsTargetsTab from "./PatientTabs/SelfSymptomsTargetsTab";
import {authenticationService} from "../../services/AuthenticationService";
import SelfPersonalDetailsTab from "./PatientTabs/SelfPersonalDetailsTab";
import {makeError} from "../../components/modals/ErrorModal";
import {history} from "../../utils/history";
import DeclarationsTab from "../doctor/PatientOnboardTabs/DeclarationsTab";
import SelfDeclarationsTab from "./PatientTabs/SelfDeclarationsTab";

class PatientSelfOnBoardConnected extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entry: {
                Phone_num1: "",
                Last_name: "",
                First_name: "",
                Phone_num2: "",
                House_number: "",
                Email: null,
                ID_passport: "",
            },
            view: 1,
            errors: {},
            errorsOnSave: {},
            israelCities: [],
            addedProducts: [],
            symptoms: [],
            symptomsList: [],
            checkboxes: {},
            productsList: [],
            medicalConditions: [],
            medicalConditionsSelected: [],
            allergics: [],
            patient_allergics: [],
            addedFilesList: [],
            medicationsList: [],
            fileForms: [],
            isUploadingFiles: false,
            isPageUploading: true,
            profilePic: null,
            general_medications: [],
            bloodThinner_medications: [],
            currentPain_medications: [],
            past_med: [],

        }
    }

    async componentDidMount() {
        let {
            general_medications, bloodThinner_medications, currentPain_medications, past_med,
            israelCities, productsList, symptomsList, medicationsList, allergics, medicalConditions, fileForms
        } = this.state

        let allData = (await patientApi.getAllData())

        if (allData) {
            allData = allData.data
            israelCities = allData.cities
            productsList = allData.products
            medicationsList = allData.medications
            allergics = allData.allergics
            medicalConditions = allData.medicalConditions
            fileForms = allData.forms
            symptomsList = allData.symptoms
        }

        this.setState({
            israelCities, productsList, symptomsList, allergics, medicalConditions, fileForms, medicationsList
        })


        let currentUser = authenticationService.currentUserValue;
        let info = currentUser ? (await patientApi.getPatientById(currentUser.profile.UserStorageID)) : ""
        info = info ? info.data : []

        let PII = info.PII ? info.PII : {}
        if (PII.Date_of_birth) {
            PII.Date_of_birth = new Date(PII.Date_of_birth)
        }

        let patientRequests = info ? info.Patient_requests : []

        info = patientRequests && patientRequests.length >= 1 ? patientRequests[0] : []
        let requestID = info.RequestID

        let Habits_Medicals = ""
        if (info.Habits_Medicals) {
            Habits_Medicals = info.Habits_Medicals.length > 0 ? info.Habits_Medicals[0] : []
        }


        let addedProducts = info.Patient_products ? info.Patient_products[0] : []
        let Patient_type_indication = info.Patient_type_indication ? info.Patient_type_indication[0] : []
        let allSymptoms = info.Patient_symptoms ? info.Patient_symptoms[0] : []
        let patient_conditions = info.Patient_conditions ? info.Patient_conditions[0] : []

        let medicalConditionsSelected = []
        for (let i = 0; i < patient_conditions.length; i++) {
            medicalConditionsSelected.push({
                value: parseInt(patient_conditions[i].Condition_ID),
                label: this.getConditionDesc(patient_conditions[i].Condition_ID)
            })
        }
        let symptoms = []
        let tCount = 0

        for (let i = 0; i < allSymptoms.length; i++) {
            if (allSymptoms[i].H_N_T === "T") {
                allSymptoms[i].Symptom_ID = tCount + allSymptoms[i].Symptom_ID
                tCount += 1
                symptoms.push(allSymptoms[i])
            }
        }

        for (let i = 0; i < addedProducts.length; i++) {
            addedProducts[i]['product_use_obj'] = {
                value: addedProducts[i].product_use,
                label: addedProducts[i].product_use
            }
            addedProducts[i].displayProducts = this.onclickChoosedCategory(addedProducts[i].product_use_category, addedProducts[i].product_type)
        }

        if (PII.Date_of_birth) {
            PII.Date_of_birth = new Date(PII.Date_of_birth)
        }

        let entry = {...PII, ...Habits_Medicals, ...Patient_type_indication}
        entry['RequestID'] = requestID


        let pAllergics = Habits_Medicals['patient_allergics'] ? Habits_Medicals.patient_allergics : ""
        pAllergics = pAllergics ? pAllergics.split(',') : ""

        let patient_allergics = []
        for (let i = 0; i < pAllergics.length; i++) {
            let index = parseInt(pAllergics[i])
            patient_allergics.push({value: index, label: this.getAllergicDesc(index)})
        }

        let profilePic = await patientApi.getProfilePic(entry.UserStorageID)
        profilePic = profilePic ? profilePic.data.Form_url : null

        let medications = info.Patient_Medications ? info.Patient_Medications[0] : []
        let isOtherPastUseMedication = false

        for (let i = 0; i < medications.length; i++) {
            if (medications[i].General_Thinner_Past === "Past") {
                if (medications[i].Medication_name === "Other") {
                    isOtherPastUseMedication = true
                }
                past_med.push({value: parseInt(medications[i].Med_ID), label: medications[i].Medication_name})
            } else {
                medications[i].MedObj = {value: medications[i].Med_ID, label: medications[i].Medication_name}
                if (medications[i].General_Thinner_Past === "G") {
                    medications[i].index = general_medications.length
                    general_medications.push(medications[i])
                } else if (medications[i].General_Thinner_Past === "T") {
                    medications[i].index = bloodThinner_medications.length
                    bloodThinner_medications.push(medications[i])
                } else if (medications[i].General_Thinner_Past === "CP") {
                    medications[i].index = currentPain_medications.length
                    currentPain_medications.push(medications[i])
                }
            }

        }
        entry.SelectedCity = {value: entry.cityID, label: this.getCityDesc(entry.cityID)}

        let addedFilesList = await patientApi.getAllUploadedFiles(entry.UserStorageID, requestID)
        addedFilesList = addedFilesList ? addedFilesList.data : []
        this.setState({
            entry,
            addedFilesList,
            profilePic,
            addedProducts,
            symptoms,
            patient_allergics,
            medicalConditionsSelected,
            general_medications,
            bloodThinner_medications,
            currentPain_medications,
            past_med,
            isPageUploading: false
        })
    }

    getCityDesc = (val) => {
        let {israelCities} = this.state
        for (let j = 0; j < israelCities.length; j++) {

            if (israelCities[j].index.toString() === val) {
                return israelCities[j].cityName
            }
        }
    }
    getAllergicDesc = (index) => {
        let {allergics} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')
        for (let j = 0; j < allergics.length; j++) {
            if (allergics[j].index === index) {
                if (language === "he") {
                    return allergics[j].Allergic_name_he
                } else {
                    return allergics[j].Allergic_name
                }
            }
        }
    }
    getConditionDesc = (index) => {
        let {medicalConditions} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')
        for (let j = 0; j < medicalConditions.length; j++) {
            if (medicalConditions[j].Condition_ID.toString() === index.toString()) {
                if (language === "he") {
                    return medicalConditions[j].Condition_description_he
                } else {
                    return medicalConditions[j].Condition_description
                }
            }
        }
    }

    changeView = (viewNum) => {
        this.setState({view: viewNum})
    }

    initValidation = async (schema) => {
        let {entry} = this.state
        let validationSchema = schema
        let errors = await validationHelper.validate(entry, validationSchema)

        this.setState({
            validationSchema,
            errors
        })
    }

    onYesNoValueChange(variable, value) {
        let {entry} = this.state
        if (entry[variable] === value) {
            this.onValueChange(variable, "")
        } else {
            this.onValueChange(variable, value)
        }
    }

    onClickCheckboxes = async (name) => {
        let {checkboxes} = this.state
        if (checkboxes.hasOwnProperty(name)) {
            checkboxes[name] = !checkboxes[name]
        } else checkboxes[name] = true

        this.onValueChange(name, checkboxes[name])
        this.setState({checkboxes})
    }

    onValueChange = async (name, value) => {
        let {entry, validationSchema} = this.state
        if (name === "Email" && value === "") {
            value = null
        }
        utils.set(entry, name, value)
        // let entryValidator = utils.removeEmptyOrNull(entry)
        let entryValidator = entry

        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;

        if (JSON.stringify(errors) === '{}') {
            errorsOnSave = errors
        }

        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }

        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }

    onClickAddProducts = async (func, value, index) => {
        let {addedProducts} = this.state
        let tempEntry = {}
        let {t} = this.props
        if (func === "ADD") {
            if (addedProducts.length === 4) {
                await AlertConfirm({
                    options: {
                        title: '',
                    }
                }, t('patient_self_boarding.maxProd'))
            } else {
                tempEntry.index = addedProducts.length
                tempEntry.product_type = "Flower"
                tempEntry.product_use_category = ""
                tempEntry.product_use = ""
                tempEntry.displayProducts = []
                addedProducts.push(tempEntry)
            }
        } else if (func === "product_use_category") {
            addedProducts[index].product_use_category = value
            addedProducts[index].displayProducts = this.onclickChoosedCategory(value, addedProducts[index].product_type)
        } else if (func === "Delete") {
            addedProducts.splice(0, addedProducts.length)
        } else if (func === "product_use_obj") {
            addedProducts[index][func] = value
            addedProducts[index]['product_use'] = value.label

        } else {
            addedProducts[index][func] = value
        }
        this.setState({addedProducts})
    }

    onclickChoosedCategory(category, type) {
        let {productsList} = this.state
        let displayProducts = []
        for (let i = 0; i < productsList.length; i++) {
            if ((category === productsList[i].Category && productsList[i].Strain === "Flower")
                || (category === productsList[i].Category && productsList[i].Strain === type)) {
                displayProducts.push(
                    {value: productsList[i].Product_name, label: productsList[i].Product_name})
            }
        }
        return displayProducts
    }

    async addDeleteTargetSymptom(name) {
        let {symptoms} = this.state
        if (name === "Add") {
            if (symptoms.length < 3) {
                symptoms.push({Symptom: "Symptom"})
                this.setState({symptoms})
            } else {
                await AlertConfirm({
                    options: {
                        title: ``,
                    }
                }, `Note that you can add max 3 symptoms`)
            }
        } else {
            const index = symptoms.indexOf(name);
            if (index > -1) {
                symptoms.splice(index, 1);
                this.setState({symptoms})
            }
        }

    }

    onClickTargetSymptom = (Symptom_ID, event, id) => {
        let {symptoms} = this.state
        for (let i = 0; i < symptoms.length; i++) {
            if (symptoms[i].Symptom_ID) {
                if (symptoms[i].Symptom_ID === Symptom_ID) {
                    if (event === "SymptomsInputSelect") {
                        symptoms[i].Symptom_ID = [i] + id
                        symptoms[i].Symptom_description = this.getSymptomsDesc(id)
                    } else if (event === "Suffer_duration") {
                        symptoms[i].Suffer_duration = id
                    } else if (event.includes("SymptomLine")) {
                        symptoms[i].Symptom_rating = id
                    } else if (event.includes("Influence")) {
                        symptoms[i].Intensity = id
                    } else if (event.includes("OtherSymptom")) {
                        symptoms[i].OtherSymptom = id
                    }
                }
                if (event === "Symptom_is_primary" && symptoms[i].Symptom_ID === Symptom_ID) {
                    if (!symptoms[i].Symptom_is_primary)
                        symptoms[i].Symptom_is_primary = id
                } else if (event === "Symptom_is_primary") {
                    symptoms[i].Symptom_is_primary = ""
                }

            } else {
                if (event === "SymptomsInputSelect") {
                    symptoms[i].Symptom_ID = [i] + id
                    symptoms[i].Symptom_description = this.getSymptomsDesc(id)

                }
            }
        }
        this.setState({symptoms})
    }

    nextButton = () => {

        let {view} = this.state

        switch (view) {
            case 1:
                this.changeView(2)
                break;
            case 2:
                this.changeView(3)
                break;
            case 3:
                this.changeView(4)
                break;
            default:
                break
        }
        let elmntToView = document.getElementById('patientTabsMainBox');
        if (elmntToView)
            elmntToView.scrollIntoView();
    }

    backButton = () => {
        let viewNum = this.state.view
        if (viewNum !== 1) {
            this.changeView(viewNum - 1)

        }
        // this.props.saveAllPatientData("")
        let elmntToView = document.getElementById('patientTabsMainBox');
        if (elmntToView)
            elmntToView.scrollIntoView();
    }

    getSymptomsDesc = (Symptom_ID) => {
        let {symptomsList} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')
        for (let j = 0; j < symptomsList.length; j++) {
            if (symptomsList[j].Symptom_ID.toString() === Symptom_ID) {
                if (language === "he") {
                    return symptomsList[j].Symptom_description_he
                } else {
                    return symptomsList[j].Symptom_description
                }
            }
        }
    }

    saveAllPatientData = async () => {

        let {t} = this.props
        let Couldnt_save_patient = t('patient_self_boarding.Couldnt_save_patient')
        let Couldnt_save_patient_message = t('patient_self_boarding.Couldnt_save_patient_message')
        let {
            entry, symptoms, checkboxes, addedProducts, patient_allergics,
            past_med,
            general_medications,
            currentPain_medications,
            bloodThinner_medications, medicalConditionsSelected
        } = this.state

        let errors = await validationHelper.validate(this.state.entry, this.state.validationSchema)

        if (!utils.isEmpty(errors)) {
            this.setState({errorsOnSave: this.state.errors, errors: this.state.errors, loading: false});
            await makeError({
                proceedLabel: t('patient_self_boarding.ok'),
                options: {
                    title: Couldnt_save_patient,
                }
            }, [Couldnt_save_patient_message]);
            return;
        }

        let allergics = ""
        if (patient_allergics) {
            for (let i = 0; i < patient_allergics.length; i++) {
                allergics = i === 0 ? patient_allergics[i].value : allergics + "," + patient_allergics[i].value
            }
        }
        entry = {...entry, ...checkboxes}
        entry.patient_allergics = allergics

        let medications = []

        medications = medications.concat(general_medications, currentPain_medications, bloodThinner_medications)

        for (let i = 0; i < past_med.length; i++) {
            let a = {Med_ID: past_med[i].value, Medication_name: past_med[i].label, General_Thinner_Past: "Past"}
            medications.push(a)
        }

        entry['LastVisitDate'] = (new Date())
        entry['symptoms'] = symptoms ? symptoms : []
        entry['medications'] = medications
        entry['isFormFullyFilled'] = true

        entry['Patient_products'] = addedProducts
        entry['medicalConditionsSelected'] = medicalConditionsSelected ? medicalConditionsSelected : []

        if (entry.Phone_num1 && !entry.Phone_num1.includes('972')) {
            entry.Phone_num1 = "972" + entry.Phone_num1.substring(1)
            this.onValueChange("Phone_num1", entry.Phone_num1)
        }

        let response = await patientApi.PatientVisit(entry, entry.UserStorageID)
        if (response) {
            authenticationService.logout();
            history.push('/login')
        } else {
            await makeError({
                proceedLabel: t('patient_self_boarding.ok'),
                options: {
                    title: Couldnt_save_patient,
                }
            }, [Couldnt_save_patient]);
        }
    }
    onclickSetProfilePic = (value) => {
        this.setState({profilePic: value})
    }

    onClickPatientAllergics(event) {
        this.setState({patient_allergics: event})
    }

    onClickMedicationConditions = (conditionsList) => {
        this.setState({medicalConditionsSelected: conditionsList})
    }
    addFileObj = async (index, selectedCategory, selectedFile) => {
        this.setState({isUploadingFiles: true})
        let {addedFilesList, entry} = this.state

        if (Object.keys(selectedFile).length !== 0 && selectedCategory !== "") {
            let fileToAdd = {
                index: index,
                selectedCategory: selectedCategory,
                selectedFile: selectedFile.value,
                file: selectedFile.files,
                UserStorageID: entry.UserStorageID,
                RequestID: entry.RequestID
            }
            let response = await patientApi.getUploadedFile(fileToAdd)
            if (response) {
                addedFilesList.push(response.data[0])
            }
        }
        this.setState({addedFilesList, isUploadingFiles: false})
    }
    onClickAddDeleteMedications = (index, event, id, type) => {
        let {
            currentPain_medications,
            bloodThinner_medications,
            general_medications,
            isOtherPastUseMedication
        } = this.state
        let medications = []
        if (type === "CP") {
            medications = currentPain_medications
        } else if (type === "GEN") {
            medications = general_medications
        } else if (type === "BT") {
            medications = bloodThinner_medications
        }
        if (id === "Med_ID") {
            medications[event]['Med_ID'] = index.value
            medications[event]['Medication_name'] = index.label
            medications[event]['MedObj'] = index
        } else if (id === "past_med") {
            let indexOther = index.find((obj => obj.label === "Other"));
            this.onValueChange("PastUseOtherMed", " ")
            isOtherPastUseMedication = !!indexOther
            this.setState({past_med: index, isOtherPastUseMedication})
        } else {
            medications[index][id] = event
        }
        if (type === "CP") {
            this.setState({currentPain_medications: medications, isOtherPastUseMedication})
        } else if (type === "GEN") {
            this.setState({general_medications: medications, isOtherPastUseMedication})
        } else if (type === "BT") {
            this.setState({bloodThinner_medications: medications, isOtherPastUseMedication})
        }
    }

    addDeleteMedication(func, index) {
        let {currentPain_medications, general_medications, bloodThinner_medications} = this.state
        if (func === "addGen") {
            general_medications.push({index: index, General_Thinner_Past: "G"})
        } else if (func === "addThinner") {
            bloodThinner_medications.push({index: index, General_Thinner_Past: "T"})
        } else if (func === "addCP") {
            currentPain_medications.push({index: index, General_Thinner_Past: "CP"})
        } else if (func === "deleteCP") {
            currentPain_medications.splice(index, 1)
        } else if (func === "deleteThinner") {
            bloodThinner_medications.splice(index, 1)
        } else if (func === "deleteGen") {
            general_medications.splice(index, 1)
        }
        this.setState({general_medications, bloodThinner_medications, currentPain_medications})
    }

    deleteUploadedFile = async (index) => {
        let {addedFilesList, entry} = this.state
        let {t} =this.props
        let fileToDelete = addedFilesList[index]
        let confirm = await AlertConfirm({
            proceedLabel: t('patient_self_boarding.continue'),
            cancelLabel: t('patient_self_boarding.cancel'),
            options: {
                title: '',
            }
        }, t('patient_self_boarding.deleteConfirm'))
        if(confirm){
            this.setState({isUploadingFiles: true})

            let res = await patientApi.deleteUploadedFiles(entry.UserStorageID, fileToDelete)
            if (res) {
                if (addedFilesList.length === 1) {
                    addedFilesList = []
                } else {
                    addedFilesList.splice(index, 1)
                }
            }
            this.setState({addedFilesList, isUploadingFiles: false})
        }

    }

    getPatientAge(birthday) {
        if (birthday !== null) {
            let todayDate = new Date().toISOString()
            let todayExactDate = (todayDate.split('T'))[0].split('-')
            let currentYear = todayExactDate[0]
            let currentMonth = todayExactDate[1]
            let birthDate = birthday ? birthday.toISOString() : ""
            let exactDate = (birthDate.split('T'))[0].split('-')
            let yearDiff = currentYear - exactDate[0]
            let monthDiff = currentMonth - exactDate[1]
            if (monthDiff < 0) {
                return (yearDiff - 1) + "." + (12 + monthDiff)
            } else {
                return yearDiff + "." + (monthDiff)
            }
        }
        return ""
    }


    render() {
        let {view, entry} = this.state
        let {t} = this.props
        let PatientName = entry.First_name + ' ' + entry.Last_name
        let id = entry.ID_passport ? entry.ID_passport : ""
        let age = this.getPatientAge(entry.Date_of_birth)
        if (this.state.isPageUploading) {
            return <div className="loader"/>
        }

        return (
            <>
                <div className={'asaya-info-selfOnboarding'}>
                    <div className={'adminMargin-title'}>
                        <div style={{display: 'flex', width: '80%'}}>
                            <label className="NewPatientTitle">{PatientName}</label>
                            <label className="NewPatientTitle2">{id}</label>
                            <label className="NewPatientTitle2">{age}</label>
                        </div>
                    </div>
                </div>
                <div className={'Patient-Screen'}>
                    <div className={'adminMargin-patientOnboard'}>
                        <div className={'self-onboard-patientTabsMainBox'} id={'patientTabsMainBox'}>
                            <div tabIndex={0} className={view === 1 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(1)}>
                                <label
                                    className={view === 1 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_self_boarding.personal_details')}</label>
                            </div>
                            <div tabIndex={0} className={view === 2 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(2)}>
                                <label
                                    className={view === 2 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_self_boarding.ReferralReason')}</label>
                            </div>
                            <div tabIndex={0} className={view === 3 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(3)}>
                                <label
                                    className={view === 3 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_self_boarding.Medical_information')}</label>
                            </div>
                            <div tabIndex={0} className={view === 4 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(4)}>
                                <label
                                    className={view === 4 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_self_boarding.cannabis_patient')}</label>
                            </div>
                            <div tabIndex={0} className={view === 5 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(5)}>
                                <label
                                    className={view === 5 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_self_boarding.declarations')}</label>
                            </div>

                            <div/>
                            <div/>

                        </div>
                        {
                            view === 1 ? (
                                    <SelfPersonalDetailsTab onValueChange={(name, value) => this.onValueChange(name, value)}
                                                            initValidation={(schema) => this.initValidation(schema)}
                                                            onclickSetProfilePic={(value) => this.onclickSetProfilePic(value)}

                                                            onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                                            entry={this.state.entry}
                                                            profilePic={this.state.profilePic}
                                                            errors={this.state.errors}
                                                            israelCities={this.state.israelCities}
                                                            cityList={this.state.cityList}
                                                            t={e => this.props.t(e)}
                                    />)
                                : view === 2 ? (
                                    <SelfSymptomsTargetsTab onValueChange={(name, value) => this.onValueChange(name, value)}
                                                            symptoms={this.state.symptoms}
                                                            isUploadingFiles={this.state.isUploadingFiles}
                                                            symptomsList={this.state.symptomsList}
                                                            fileForms={this.state.fileForms}
                                                            addedFilesList={this.state.addedFilesList}
                                                            addFileObj={(index, selectedCategory, selectedFile) => this.addFileObj(index, selectedCategory, selectedFile)}
                                                            deleteUploadedFile={(index) => this.deleteUploadedFile(index)}
                                                            t={e => this.props.t(e)}
                                                            addDeleteTargetSymptom={(name) => this.addDeleteTargetSymptom(name)}
                                                            onClickTargetSymptom={(SymptomsInput, name, id) => this.onClickTargetSymptom(SymptomsInput, name, id)}
                                    />
                                ) : view === 3 ? (
                                    <SelfMedicalInfoTab onValueChange={(name, value) => this.onValueChange(name, value)}
                                                        entry={this.state.entry}
                                                        allergics={this.state.allergics}
                                                        medicalConditions={this.state.medicalConditions}
                                                        medicalConditionsSelected={this.state.medicalConditionsSelected}
                                                        patient_allergics={this.state.patient_allergics}
                                                        onClickPatientAllergics={(value) => this.onClickPatientAllergics(value)}
                                                        onClickMedicationConditions={(value) => this.onClickMedicationConditions(value)}
                                                        initValidation={(schema) => this.initValidation(schema)}
                                                        onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                                        errors={this.state.errors}
                                                        general_medications={this.state.general_medications}
                                                        bloodThinner_medications={this.state.bloodThinner_medications}
                                                        currentPain_medications={this.state.currentPain_medications}
                                                        past_med={this.state.past_med}
                                                        medicationsList={this.state.medicationsList}
                                                        onClickAddDeleteMedications={(index, event, id, type) => this.onClickAddDeleteMedications(index, event, id, type)}
                                                        addDeleteMedication={(func, index) => this.addDeleteMedication(func, index)}
                                                        t={e => this.props.t(e)}
                                    />) : view === 4 ? (
                                    <SelfUseOfCannabisTab onValueChange={(name, value) => this.onValueChange(name, value)}
                                                          onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                                          initValidation={(schema) => this.initValidation(schema)}
                                                          onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                                          entry={this.state.entry}
                                                          addedProducts={this.state.addedProducts}
                                                          checkboxes={this.state.checkboxes}
                                                          errors={this.state.errors}
                                                          productsList={this.state.productsList}
                                                          t={e => this.props.t(e)}
                                                          onClickAddProducts={(func, value, index) => this.onClickAddProducts(func, value, index)}

                                    />) : view === 5 ? (<SelfDeclarationsTab
                                    onValueChange={(name, value) => this.onValueChange(name, value)}
                                    onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                    entry={this.state.entry}
                                    errors={this.state.errors}
                                    t={e => this.props.t(e)}

                                />) : <div>

                                </div>
                        }
                        <div className={'backBox'}>
                            <div className={'backBoxRighting'} onClick={this.backButton.bind(this)}
                                 style={{display: view !== 1 ? 'block' : 'none'}}>
                                {t('patient_self_boarding.back')}
                            </div>

                            <div className={view !== 1 ? 'selfNextButton2' : 'selfNextButton'}
                                 onClick={() => this.saveAllPatientData()}>
                                {t('patient_self_boarding.save_exit')}
                            </div>

                            <div className={view !== 1 ? 'selfNextButton2' : 'selfNextButton'}
                                 onClick={() => this.nextButton()} style={{display: view !== 5 ? 'block' : 'none'}}>
                                {t('patient_self_boarding.next')}
                            </div>


                        </div>

                    </div>
                </div>
            </>
        )
    }

}

const PatientSelfOnBoard = compose(
    withTranslation(),
    connect(
        /*        mapStateToProps,
                mapDispatchToProps*/
    )
)(PatientSelfOnBoardConnected)

export default PatientSelfOnBoard;
